import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router';
import { Login } from './pages/Login/Login';
import './App.scss';
import { useGQLLazyQuery } from './ui/utils/graphql';
import { AUTH } from './graphql/user';
import { Loading } from './ui/components/Loading/Loading';
import { SessionExpired } from './pages/SessionExpired/SessionExpired';
import { Layout } from './pages/Layout/Layout';
import { Appointments } from './pages/Appointments/Appointments';
import { BusinessConfiguration } from './pages/BusinessConfiguration/BusinessConfiguration';
import { NewAppointment } from './pages/NewAppointment/NewAppointment';
import { Services } from './pages/ServiceFlow/Services/Services';
import { ServiceCreate } from './pages/ServiceFlow/ServiceCreate/ServiceCreate';
import { MyClients } from './pages/Layout/ClientFlow/MyClients/MyClients';
import { NewClient } from './pages/Layout/ClientFlow/NewClient/NewClient';
import { AppointmentsHistory } from './pages/Appointments/_components/AppointmentsHistory/AppointmentsHistory';
import { Landing } from './pages/Landing/Landing';

export const App = () => {
  const [role, setRole] = useState(undefined);
  const navigate = useNavigate();
  const [sessionExpired, setSessionExpired] = useState(false);
  const { data, loading, lazy } = useGQLLazyQuery<
    { role: string },
    { token: string }
  >(
    AUTH,

    {
      onError: (err) => {
        if (err.graphQLErrors[0].extensions?.code === 'SESSION_EXPIRED') {
          setSessionExpired(true);
          localStorage.removeItem('token');

          const timeout = setTimeout(() => {
            setSessionExpired(false);
            window.location.replace('/');
            clearTimeout(timeout);
          }, 4_000);
        }
      },
    }
  );

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      navigate('/');
      return;
    }

    lazy({
      variables: {
        token: localStorage.getItem('token') || '',
      },
    });

    setRole(data?.role);
  }, [data]);

  const switchAuth = (): React.ReactElement => {
    if (loading) {
      return <Loading fullScreen />;
    }

    if (sessionExpired) {
      return <SessionExpired />;
    }

    // if (role === 'ADMIN') {
    //   return (
    //     <Routes>
    //       <Route path="/" element={<div>123 admin</div>} />
    //     </Routes>
    //   );
    // }

    if (role === 'ADMIN') {
      return (
        <Routes>
          <Route element={<Layout />}>
            <Route path="/appointments">
              <Route index element={<Appointments />} />
              <Route
                path="/appointments/new-appointment"
                element={<NewAppointment />}
              />
              <Route
                path="/appointments/history"
                element={<AppointmentsHistory />}
              />
            </Route>
            <Route path="/clients">
              <Route index element={<MyClients />} />
              <Route path="/clients/create" element={<NewClient />} />
            </Route>
            <Route
              path="/configuration/business"
              element={<BusinessConfiguration />}
            />
            <Route path="/services">
              <Route index element={<Services />} />
              <Route path="/services/create" element={<ServiceCreate />} />
            </Route>
          </Route>
        </Routes>
      );
    }

    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" index element={<Landing />} />
      </Routes>
    );
  };

  return switchAuth();
};
